/**
 * @generated SignedSource<<38de30c5addeedd3307ff4a37f5bc21e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrganizationsPage_organizations$data = {
  readonly organizations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly accessPoints: {
          readonly totalCount: number;
        } | null;
        readonly docks: {
          readonly totalCount: number;
        } | null;
        readonly id: string;
        readonly name: string;
        readonly users: {
          readonly totalCount: number;
        } | null;
        readonly uuid: string;
        readonly vehicles: {
          readonly totalCount: number;
        } | null;
      } | null;
    } | null>;
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "OrganizationsPage_organizations";
};
export type OrganizationsPage_organizations$key = {
  readonly " $data"?: OrganizationsPage_organizations$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrganizationsPage_organizations">;
};

import OrganizationsRefetchQuery_graphql from './OrganizationsRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "organizations"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dataLevel"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dockedFlashpackChannelUuids"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeDataLevel"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeGroupUuids"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "groupUuids"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hasDockTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hasVehicleTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "noDockOfTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "noVehicleOfTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "nondockedFlashpackChannelUuids"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orgTiers"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchTerm"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": OrganizationsRefetchQuery_graphql
    }
  },
  "name": "OrganizationsPage_organizations",
  "selections": [
    {
      "alias": "organizations",
      "args": [
        {
          "kind": "Variable",
          "name": "dataLevel",
          "variableName": "dataLevel"
        },
        {
          "kind": "Variable",
          "name": "dockedFlashpackChannelUuids",
          "variableName": "dockedFlashpackChannelUuids"
        },
        {
          "kind": "Variable",
          "name": "excludeDataLevel",
          "variableName": "excludeDataLevel"
        },
        {
          "kind": "Variable",
          "name": "excludeGroupUuids",
          "variableName": "excludeGroupUuids"
        },
        {
          "kind": "Variable",
          "name": "groupUuids",
          "variableName": "groupUuids"
        },
        {
          "kind": "Variable",
          "name": "hasDockTypes",
          "variableName": "hasDockTypes"
        },
        {
          "kind": "Variable",
          "name": "hasVehicleTypes",
          "variableName": "hasVehicleTypes"
        },
        {
          "kind": "Variable",
          "name": "noDockOfTypes",
          "variableName": "noDockOfTypes"
        },
        {
          "kind": "Variable",
          "name": "noVehicleOfTypes",
          "variableName": "noVehicleOfTypes"
        },
        {
          "kind": "Variable",
          "name": "nondockedFlashpackChannelUuids",
          "variableName": "nondockedFlashpackChannelUuids"
        },
        {
          "kind": "Variable",
          "name": "orgTiers",
          "variableName": "orgTiers"
        },
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        }
      ],
      "concreteType": "OrganizationConnection",
      "kind": "LinkedField",
      "name": "__OrganizationsList_organizations_connection",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Organization",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VehicleConnection",
                  "kind": "LinkedField",
                  "name": "vehicles",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserConnection",
                  "kind": "LinkedField",
                  "name": "users",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DockConnection",
                  "kind": "LinkedField",
                  "name": "docks",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessPointConnection",
                  "kind": "LinkedField",
                  "name": "accessPoints",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "1ac4bf01728932162fde378407b3d761";

export default node;
